import { startMocking } from '@/shared/api'
import { initI18n } from '@/shared/i18n'
import { initObservability } from '@/shared/observability'

// Bootstrap до рендера: i18n, observability, MSW (в mock-режиме). Реакция на 401
// (истёкшая/отсутствующая hub-сессия) живёт в самом HTTP-клиенте — увод на единый
// SSO id.stit.tech (00-architecture § 3). Публичные booking-ручки 401 не отдают.
export async function bootstrap(): Promise<void> {
  await initI18n()
  initObservability()
  await startMocking()
}
